(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["barkwood-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('barkwood-pack-form')) {
  customElements.define('barkwood-pack-form', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.selector = this.querySelector('[data-bw-variant]');
      if (!this.selector) return;
      this.selector.addEventListener('change', () => this.updatePack());
      this.updatePack();
    }
    updatePack() {
      const option = this.selector.selectedOptions[0];
      if (!option) return;
      const count = Number(option.dataset.count) || 1;
      this.querySelectorAll('[data-bw-name]').forEach(group => {
        const active = Number(group.dataset.bwName) <= count;
        group.hidden = !active;
        const input = group.querySelector('input');
        input.disabled = !active;
        input.required = active;
      });
      const price = this.closest('.bw-product-page')?.querySelector('.bw-product-price');
      if (price) {
        price.textContent = '';
        const saleActive = Date.now() >= 1793306570000 && Date.now() < 1793911370000;
        if (saleActive && option.dataset.salePrice) {
          const original = document.createElement('s');
          original.textContent = option.dataset.price;
          original.style.cssText = 'font-size:.75em;opacity:.65;margin-right:.5em';
          const sale = document.createElement('strong');
          sale.textContent = option.dataset.salePrice;
          price.append(original, sale);
        } else {
          price.textContent = option.dataset.price;
        }
      }
      const button = this.querySelector('button[type="submit"]');
      if (button) button.disabled = option.disabled;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
